module.exports = "/assets/fonts/863edca7.svg";